import { ICanvasScaler } from "../../../../../canvas/ICanvasScaler";
import { PromiseCompletionSource } from "async/PromiseCompletionSource";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { IShopController } from "../controller/IShopController";
import { IShopModel } from "../model/IShopModel";
import { ShopResourcePackage } from "../resources/ShopResourcePackage";
import { ShopPage } from "./page/ShopPage";
import { BaseScalableView } from "../../../common/BaseScalableView";
import { ILogger } from "../../../../logger/ILogger";
import { AsyncOperationNotification } from "../../../common/components/AsyncOperationNotification";
import { CancellationToken } from "async/CancellationToken";
import { IDestroyOptions } from "pixi.js";
import { Web3Model } from "../../../../../web3/models/Web3Model";
import { IAnalyticProviderWrapper } from "../../../../../analytics/IAnalyticProviderWrapper";

export class ShopPopupView extends BaseScalableView<void> {

    private readonly cancellationToken: CancellationToken;
    private readonly commonResources: CommonResourcesPackage;
    private readonly shopResources: ShopResourcePackage;
    private readonly shopModel: IShopModel;
    private readonly shopController: IShopController;
    private readonly logger: ILogger;
    private readonly asyncOperationNotification: AsyncOperationNotification;
    private readonly web3Model: Web3Model;
    private readonly analyticsProvider: IAnalyticProviderWrapper;

    public constructor(
        operationControls: PromiseCompletionSource<void>,
        cancellationToken: CancellationToken,
        shopResources: ShopResourcePackage,
        commonResources: CommonResourcesPackage,
        canvasScaler: ICanvasScaler,
        shopModel: IShopModel,
        shopController: IShopController,
        logger: ILogger,
        asyncOperationNotification: AsyncOperationNotification,
        web3Model: Web3Model,
        analyticsProvider: IAnalyticProviderWrapper
    ) {
        super(operationControls, canvasScaler);
        this.cancellationToken = cancellationToken;
        this.shopResources = shopResources;
        this.commonResources = commonResources;
        this.shopModel = shopModel;
        this.shopController = shopController;
        this.logger = logger;
        this.asyncOperationNotification = asyncOperationNotification;
        this.web3Model = web3Model;
        this.analyticsProvider = analyticsProvider;

        this.cancellationToken.onCanceled.add(this.onCancellationRequested, this);
    }

    public async start(): Promise<void> {
        const shopPageCS = new PromiseCompletionSource<void>();
        const shopPage = new ShopPage(
            shopPageCS,
            this.cancellationToken,
            this.shopResources,
            this.commonResources,
            this.canvasScaler,
            this.shopModel,
            this.shopController,
            this.logger,
            this.asyncOperationNotification,
            this.web3Model,
            this.analyticsProvider
        );
        this.addChild(shopPage);
        await shopPageCS.result;
        this.removeChild(shopPage);
        this.operationControls.complete();
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.cancellationToken.onCanceled.remove(this.onCancellationRequested, this);
        super.destroy(options);
    }

    private onCancellationRequested(): void {
        this.operationControls.complete();
        this.destroy();
    }
}
